import React from "react";
import { ChevronDown, Sparkles } from "lucide-react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_30ef4267-c09d-4b15-855e-926148380f56/artifacts/rdftw6s8_IMG_7302.jpeg";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 64;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[100vh] w-full flex items-center overflow-hidden kip-grain"
    >
      {/* Background image */}
      <div
        aria-hidden
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{ backgroundImage: `url(${HERO_IMG})` }}
      />
      {/* Overlay */}
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(90deg, rgba(15,26,46,0.95) 0%, rgba(15,26,46,0.75) 45%, rgba(15,26,46,0.35) 100%)",
        }}
      />
      {/* Orange accent line bottom */}
      <div
        aria-hidden
        className="absolute bottom-0 left-0 right-0 h-1 bg-[#E85D26]"
      />

      <div className="relative z-10 kip-container w-full pt-28 pb-24">
        <div className="max-w-3xl">
          {/* Partner badge */}
          <div
            data-testid="hero-partner-badge"
            className="inline-flex items-center gap-2 px-3 py-2 mb-8 bg-white/10 backdrop-blur-md border border-white/20"
          >
            <Sparkles size={14} className="text-[#E85D26]" />
            <span className="text-xs sm:text-sm tracking-[0.14em] uppercase text-white font-medium">
              Distributeur Exclusif Wayne — Côte d'Ivoire
            </span>
          </div>

          <span className="kip-accent-bar" />

          <h1
            data-testid="hero-headline"
            className="font-display font-black text-white text-4xl sm:text-5xl lg:text-7xl leading-[1.05] tracking-tight"
          >
            L'énergie qui{" "}
            <span className="text-[#E85D26]">propulse</span> la
            <br className="hidden sm:block" /> Côte d'Ivoire.
          </h1>

          <p
            data-testid="hero-subhead"
            className="mt-6 text-lg sm:text-xl text-white/80 max-w-2xl leading-relaxed"
          >
            Distributeur exclusif Wayne · Solutions pétrolières et mobilité
            intégrées pour bâtir le premier écosystème énergétique d'Afrique de
            l'Ouest.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <button
              data-testid="hero-cta-primary"
              onClick={() => scrollTo("metiers")}
              className="btn-primary"
            >
              Découvrir nos solutions
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={() => scrollTo("contact")}
              className="btn-outline-white"
            >
              Nous contacter
            </button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={() => scrollTo("stats")}
        data-testid="hero-scroll-indicator"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-white/80 hover:text-white flex flex-col items-center gap-1"
        aria-label="Défiler"
      >
        <span className="text-[10px] tracking-[0.3em] uppercase">Défiler</span>
        <ChevronDown size={22} className="chevron-bob" />
      </button>
    </section>
  );
}
